function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m9.3332 1.3335h-5.3333c-.74 0-1.3333.6-1.3333 1.3333v10.667c0 .7333.6 1.3333 1.3333 1.3333h8c.7334 0 1.3334-.6 1.3334-1.3333v-8l-4-4zm.33333 11.267-1.6667-.9334-1.6667 1 .46667-1.8666-1.4667-1.2667 1.9333-.13334.73334-1.8.73333 1.7333 1.9333.13333-1.4667 1.2667.46666 1.8667zm-1-6.6v-3.6667l3.6667 3.6667h-3.6667z",
  fill: "currentColor"
}));
function SvgFileStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "static/2.5.2/media/fileStar.89697ce5.svg";
export { SvgFileStar as ReactComponent };